import axios from "axios";

const serviceRequestTimeoutMs = 10000;

export const throwIfForthLeafRequestAborted = (signal: AbortSignal) => {
  if (signal.aborted) {
    const abortError = new Error("Forth Leaf service request was aborted.");
    abortError.name = "AbortError";
    throw abortError;
  }
};

export class ForthLeafTokenAcquisitionError extends Error {
  constructor(cause: unknown) {
    super("Forth Leaf access token acquisition failed.", { cause });
    this.name = "ForthLeafTokenAcquisitionError";
  }
}

export const acquireForthLeafAccessToken = async (
  getAccessTokenSilently: () => Promise<string>,
  signal: AbortSignal,
) => {
  let token: string;

  try {
    token = await getAccessTokenSilently();
  } catch (error) {
    throw new ForthLeafTokenAcquisitionError(error);
  }

  throwIfForthLeafRequestAborted(signal);
  return token;
};

export const createForthLeafServiceClient = (baseURL: string, token: string) =>
  axios.create({
    baseURL,
    headers: { Authorization: `Bearer ${token}` },
    timeout: serviceRequestTimeoutMs,
  });

export const getForthLeafServiceResponseStatus = (error: unknown) => {
  if (error instanceof ForthLeafTokenAcquisitionError) {
    return undefined;
  }

  return axios.isAxiosError(error) ? error.response?.status : undefined;
};
